/**
 * Express area kind
 */
export enum AreaKind {
  DEFAULT = 0,
  ACCESS_CONTROL_GROUP_OF_ENVIRONMENT = 1,
}

/**
 * Environments children level when reading the environments of an area ("childAreaLevel" on /api/environment)
 */
export enum ChildAreaLevel {
  /** Only the environments of the given area */
  NONE = 0,
  /** The environments of the given area and of its direct children */
  FIRST_CHILD = 1,
  /** The environments of the given area and of all its descendants */
  ALL_CHILD = 2,
}
